import axios from "axios";
import { toast } from "react-toastify";
import { API_ENDPOINTS } from "./apiEndpoints";

const BASE_URL = "https://dev.api.morbibazaar.com/api/v1/";

const apiClient = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { response, config: originalRequest } = error;
    if (!response) {
      toast.error("Network error. Please check your connection.");
      return Promise.reject(error);
    }
    if (response.status === 401) {
      try {
        const refreshToken = sessionStorage.getItem("refreshToken");
        if (!refreshToken) {
          sessionStorage.clear();
          window.location.href = "/login";
          return Promise.reject(error);
        }
        const refreshResp = await axios.post(
          `${BASE_URL}${API_ENDPOINTS.ACCOUNTS.TOKEN_REFRESH}`,
          { refresh: refreshToken }
        );
        const newAccessToken = refreshResp.data?.access;
        if (!newAccessToken) {
          sessionStorage.clear();
          window.location.href = "/login";
          return Promise.reject(error);
        }
        sessionStorage.setItem("accessToken", newAccessToken);
        apiClient.defaults.headers.common["Authorization"] = `Bearer ${newAccessToken}`;
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
        return apiClient(originalRequest);
      } catch (err) {
        console.error("Refresh token failed:", err);
        sessionStorage.clear();
        window.location.href = "/login";
        return Promise.reject(err);
      }
    } else if (response.status === 403) {
      toast.error("You don't have permission to access this resource. Please contact your administrator.");
      sessionStorage.clear();
      window.location.href = "/login";
      return Promise.reject(error);
    }
    // toast.error(response.data?.message || "An error occurred");
    return Promise.reject(error);
  }
);
export const apiService = {
  get: async (url, config = {}) => {
    const response = await apiClient.get(url, config);
    return response.data;
  },

  post: async (url, data = {}, config = {}) => {
    const response = await apiClient.post(url, data, config);
    return response.data;
  },

  put: async (url, data = {}, config = {}) => {
    const response = await apiClient.put(url, data, config);
    return response.data;
  },

  patch: async (url, data = {}, config = {}) => {
    const response = await apiClient.patch(url, data, config);
    return response.data;
  },

  delete: async (url, config = {}) => {
    const response = await apiClient.delete(url, config);
    return response.data;
  },

  upload: async (url, formData, config = {}) => {
    const response = await apiClient.post(url, formData, {
      ...config,
      headers: {
        "Content-Type": "multipart/form-data",
        ...config.headers,
      },
    });
    return response.data;
  },
};

export default apiService;
